import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/conservation`;

export const conservationService = {
  runCheck: async (triggeredBy = 'ui_request') => {
    const response = await axios.post(`${API_BASE}/check`, { triggered_by: triggeredBy });
    return response.data;
  },

  getLatest: async () => {
    const response = await axios.get(`${API_BASE}/latest`);
    return response.data;
  },

  getHistory: async ({ limit = 50, offset = 0 } = {}) => {
    const response = await axios.get(`${API_BASE}/history?limit=${limit}&offset=${offset}`);
    return response.data;
  }
};

export default conservationService;
